import React from 'react';
import TextInput from '@/Shared/TextInput';
import SelectInput from '@/Shared/SelectInput';
import CustomCheckbox from '@/Shared/CustomCheckbox';
import ImageInput from "@/Shared/ImageInput";
import TextArea from "@/Shared/TextArea";
import DateInput from "@/Shared/DateInput";

const CategoryForm = ({data, errors, setData}) => {
  return (
    <div className="flex flex-wrap p-8 -mb-8 -mr-6">
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Category Title"
        name="category_title"
        type="text"
        errors={errors.category_title}
        value={data.category_title}
        onChange={e => setData('category_title', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Page Title"
        name="page_title"
        type="text"
        errors={errors.page_title}
        value={data.page_title}
        onChange={e => setData('page_title', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Short title"
        name="short_title"
        type="text"
        errors={errors.short_title}
        value={data.short_title}
        onChange={e => setData('short_title', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Relative URL"
        name="relative_url"
        type="text"
        errors={errors.relative_url}
        value={data.relative_url}
        onChange={e => setData('relative_url', e.target.value)}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Show Online"
        name="showonline"
        errors={errors.showonline}
        checked={data.showonline}
        onChange={e => setData('showonline', !!e.target.checked)}
      />
      <CustomCheckbox
        className="w-full pb-8 pr-6"
        label="Make Visible"
        name="make_visible"
        errors={errors.make_visible}
        checked={data.make_visible}
        onChange={e => setData('make_visible', !!e.target.checked)}
      />
      <ImageInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Image Logo"
        name="def_image_logo"
        errors={errors.def_image_logo}
        value={data.def_image_logo}
        onChange={def_image_logo => setData('def_image_logo', def_image_logo)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Rank"
        name="rank"
        type="number"
        errors={errors.rank}
        value={data.rank}
        onChange={e => setData('rank', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Keywords"
        name="keywords"
        errors={errors.keywords}
        value={data.keywords}
        onChange={e => setData('keywords', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="On-Page Description"
        name="category_description"
        errors={errors.category_description}
        value={data.category_description}
        onChange={e => setData('category_description', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Meta Description"
        name="meta_description"
        errors={errors.meta_description}
        value={data.meta_description}
        onChange={e => setData('meta_description', e.target.value)}
      />
        Coupon Expiration Range:
        <DateInput
          date={data.start_date}
          setDate={setData}
          valueName={'start_date'}
          label={'Start Date'}
          errors={errors.start_date}
        />
        <DateInput
          date={data.expire_date}
          setDate={setData}
          valueName={'expire_date'}
          label={'Expiration Date'}
          errors={errors.expire_date}
        />
    </div>
  );
};

export default CategoryForm;
